module.exports = __webpack_public_path__ + "static/fonts/fontawesome-webfont.4f0022f.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/fontawesome-webfont.ttf?v=4.1.0
// module id = W84a
// module chunks = 1